import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 13 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.3447 6.53466L6.88524 0.670386C6.67375 0.443205 6.32626 0.443205 6.11475 0.670386L0.655251 6.53466C0.320701 6.89401 0.562544 7.5 1.04049 7.5L11.9595 7.5C12.4375 7.5 12.6793 6.89401 12.3447 6.53466Z",
      fill: "#EBEBEB"
    }, null, -1)
  ]))]))
}
export default { render: render }